import Vue from 'vue';
import { getters } from '@/modules/core/app/helpers/store';

Vue.prototype.$isExporting = () => getters.export.isExporting();
